// Mock data for Aurelia Concierge Wellness Partners

export const IMAGES = {
  hero: '/generated/hero_phlebotomy.png',
  medicalBag: '/generated/medical_case.png',
  bloodVials: '/generated/vials_tray.png',
  luxuryInterior: '/generated/luxury_interior.png',
  cprTraining: '/generated/cpr_training.png',
  luxuryCar: '/generated/medical_case.png',
  business: '/generated/business_meeting.png',
  doctor: '/generated/team_portrait.png',
  phlebotomy: '/generated/hero_phlebotomy.png',
  executiveConsult: '/generated/executive_consult.png',
  faqOffice: '/generated/faq_office.png',
  contactDesk: '/generated/contact_desk.png',
};

export const NAV_LINKS = [
  { label: 'HOME', path: '/' },
  { label: 'SERVICES', path: '/services' },
  { label: 'ABOUT', path: '/about' },
  { label: 'FOR BUSINESS', path: '/for-business' },
  { label: 'PATIENT FORMS', path: '/patient-forms' },
  { label: 'FAQ', path: '/faq' },
  { label: 'POLICIES', path: '/policies' },
  { label: 'CONTACT & PAY', path: '/contact' },
];

export const HOME_TRUST_BADGES = [
  { icon: 'ShieldCheck', label: 'LICENSED &\nINSURED' },
  { icon: 'Lock', label: 'HIPAA\nCOMPLIANT' },
  { icon: 'Clock', label: 'PUNCTUAL.\nPROFESSIONAL.' },
  { icon: 'User', label: 'PATIENT\nFOCUSED' },
];

export const LIFESTYLE_FEATURES = [
  {
    icon: 'Home',
    title: 'AT HOME',
    description: 'Private, comfortable care in the safety of your own home.',
  },
  {
    icon: 'Briefcase',
    title: 'AT WORK',
    description: 'We come to your office to save you time and support your team.',
  },
  {
    icon: 'CalendarDays',
    title: 'FLEXIBLE SCHEDULING',
    description: 'Early mornings, evenings, and weekends available to fit your schedule.',
  },
  {
    icon: 'ShieldCheck',
    title: 'DISCREET & RELIABLE',
    description: 'Your health is personal. Your care should be too. We protect your privacy.',
  },
];

export const WHY_CHOOSE_CARDS = [
  {
    image: '/generated/team_portrait.png',
    title: 'EXPERT\nPHLEBOTOMISTS',
    description: 'Highly trained professionals with years of experience.',
  },
  {
    image: '/generated/medical_case.png',
    title: 'CONVENIENCE\nDELIVERED',
    description: 'We bring everything needed to you.',
  },
  {
    image: '/generated/luxury_interior.png',
    title: 'PREMIUM\nEXPERIENCE',
    description: 'High-touch service with attention to every detail.',
  },
  {
    image: '/generated/vials_tray.png',
    title: 'RESULTS YOU\nCAN TRUST',
    description: 'Accurate, timely results handled with integrity.',
  },
];

export const SERVICES = [
  {
    number: 'SERVICE 01',
    title: 'Mobile Phlebotomy',
    image: '/generated/hero_phlebotomy.png',
    icon: 'TestTubes',
    description:
      'Expert blood collection services brought directly to you. Ideal for busy professionals, families, and those who value privacy, comfort, and convenience.',
    features: [
      'Routine Lab Work',
      'Specialty Testing',
      'Wellness Panels',
      'Corporate & Executive Health',
      'Cash Pay (Concierge) or Provider Lab Requisitions',
    ],
  },
  {
    number: 'SERVICE 02',
    title: 'BLS CPR Classes',
    image: '/generated/cpr_training.png',
    icon: 'HeartPulse',
    description:
      'American Heart Association BLS CPR certification courses designed to equip you with the skills and confidence to save lives.',
    features: [
      'BLS Provider Certification',
      'Flexible Scheduling',
      'On-Site Group Training',
      'Healthcare Providers & Students',
      'Corporate & Community Training',
    ],
  },
  {
    number: 'SERVICE 03',
    title: 'DNA Testing',
    image: '/generated/dna_testing.png',
    icon: 'Dna',
    description:
      'Discreet, precise DNA collection performed by certified professionals \u2014 with strict chain-of-custody for legal cases and simple, private processing for personal peace of mind.',
    features: [
      'Legal (Court-Admissible) DNA Testing',
      'Non-Legal / Personal DNA Testing',
      'Paternity & Maternity Panels',
      'Sibling & Ancestry Verification',
      'Strict Chain-of-Custody Protocols',
    ],
  },
  {
    number: 'SERVICE 04',
    title: 'Drug & Urine Screenings',
    image: '/generated/drug_screening.png',
    icon: 'FlaskConical',
    description:
      'Fully compliant DOT and Non-DOT drug and urine screening services for individuals and organizations \u2014 conducted with dignity, discretion, and complete documentation.',
    features: [
      'DOT Drug & Alcohol Screening',
      'Non-DOT Employer Panels',
      'Pre-Employment & Random Testing',
      'Court-Ordered & Probation Testing',
      'On-Site Corporate Collection',
    ],
  },
];

export const CLIENT_TYPES = [
  'Medical practices',
  'Dental offices',
  'Med spas',
  'Wellness clinics',
  'Concierge medical practices',
  'Functional medicine practices',
  'Home healthcare agencies',
  'Assisted living organizations',
  'Staffing agencies',
  'Construction companies',
  'Transportation companies',
  'Trucking companies',
  'Delivery companies',
  'Fleet operators',
  'Corporate offices',
  'Law firms',
  'Financial firms',
  'Private practices',
  'Wellness companies',
];

export const AURELIA_STANDARDS = [  {
    icon: 'ShieldCheck',
    title: 'LICENSED & INSURED',
    description: 'Fully certified professionals with the highest standards of safety and care.',
  },
  {
    icon: 'Lock',
    title: 'HIPAA COMPLIANT',
    description: 'Your privacy is our priority. All services are HIPAA compliant and secure.',
  },
  {
    icon: 'Clock',
    title: 'PUNCTUAL & RELIABLE',
    description: 'We value your time and arrive prepared, on time, every time.',
  },
  {
    icon: 'User',
    title: 'PATIENT FOCUSED',
    description: 'Compassionate care tailored to your unique needs and schedule.',
  },
];

export const ABOUT_VALUES = [
  {
    icon: 'Sparkles',
    title: 'Excellence',
    description: 'We hold ourselves to uncompromising clinical and service standards in every interaction.',
  },
  {
    icon: 'Heart',
    title: 'Compassion',
    description: 'Every patient is treated with warmth, dignity, and personalized attention.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Integrity',
    description: 'Discretion, honesty, and privacy are the foundation of our practice.',
  },
  {
    icon: 'Clock',
    title: 'Reliability',
    description: 'Punctual, prepared, and consistent \u2014 we honor your time and trust.',
  },
];

export const BUSINESS_OFFERINGS = [
  {
    icon: 'Building2',
    title: 'Corporate Wellness Programs',
    description: 'Comprehensive on-site health screenings, wellness panels, and executive physicals designed for high-performing teams.',
  },
  {
    icon: 'GraduationCap',
    title: 'On-Site CPR & BLS Training',
    description: 'American Heart Association-certified training brought directly to your workplace for teams of any size.',
  },
  {
    icon: 'Users',
    title: 'Employee Health Events',
    description: 'Turn-key wellness days with mobile lab services, biometrics, and educational sessions.',
  },
  {
    icon: 'Briefcase',
    title: 'Executive Concierge Care',
    description: 'White-glove phlebotomy and wellness services for leadership \u2014 discreet, scheduled, and delivered on your terms.',
  },
];

export const FAQS = [
  {
    q: 'What areas do you serve?',
    a: 'Aurelia Concierge Wellness Partners serves the greater Atlanta, GA metropolitan area and surrounding communities. For appointments outside this area, please contact us directly.',
  },
  {
    q: 'Are your phlebotomists licensed and insured?',
    a: 'Absolutely. Every member of our clinical team is fully licensed, certified, and insured. We maintain rigorous credentialing standards to ensure the highest level of safety and expertise.',
  },
  {
    q: 'Is my information kept private?',
    a: 'Yes. We are fully HIPAA compliant. Your health information, appointment details, and results are handled with strict confidentiality at every step.',
  },
  {
    q: 'How do you accept payment?',
    a: 'Aurelia services insured patients with a valid doctor’s order only. Any out-of-pocket amount (such as a concierge fee or copay) is processed securely through our Square point-of-sale system before services are rendered. For your convenience we also accept Afterpay — our buy-now-pay-later option. We do not bill insurance directly, but we honor the laboratory requisition provided by your ordering healthcare provider.',
  },
  {
    q: 'How do I prepare for a mobile phlebotomy appointment?',
    a: 'Preparation depends on the specific tests ordered. If fasting is required, we will provide you with clear instructions when your appointment is confirmed.',
  },
  {
    q: 'How quickly will I receive my results?',
    a: 'Turnaround times vary by test type, but most routine lab results are available within 24\u201348 hours. Specialty testing may take longer, and we will keep you informed.',
  },
  {
    q: 'Do you offer BLS CPR training for individuals or only groups?',
    a: 'We offer both. Individuals can join scheduled classes, and we also provide on-site group training for corporate teams, healthcare organizations, and community groups.',
  },
  {
    q: 'How do I book an appointment?',
    a: 'You can book directly through our online form, or contact us by phone or email. We offer early mornings, evenings, and weekend availability.',
  },
];

export const CONTACT_INFO = {
  phone: '(470) 223-8557',
  email: 'aureliaconciergewellness@gmail.com',
  area: 'Atlanta, GA & Surrounding Areas',
  hours: 'Sun \u2013 Sat \u00B7 8:30 AM \u2013 5:00 PM',
};
